import Fuse from 'fuse.js';
import moment from 'moment';
import { Meeting, MeetingSettings } from 'api/meeting/types';
import { TimesheetCalendarSourceType } from 'api/timesheets';
import { isSameCentury } from 'components/atoms/humanised-date';
import { MeetingCompanyFilterType } from './meetings-selector-v2/meeting-selector-content';

export const getDateForMeetingsCalendar = (timestamp: number) => {
  const date = moment(timestamp);
  const isToday = moment().isSame(date, 'day');
  const isYesterday = moment().isSame(date.clone().add(1, 'day'), 'day');

  if (isToday) {
    return 'Today';
  }
  if (isYesterday) {
    return 'Yesterday';
  }

  return date.format(
    `D MMM${
      !moment().isSame(date, 'year')
        ? isSameCentury(date)
          ? ' YY'
          : ' YYYY'
        : ''
    }`,
  );
};

export const getTimeForMeetingsCalendar = (
  startTime: number,
  endTime: number,
  seperator?: string,
) => {
  const startTS = moment(startTime);
  const endTs = moment(endTime);
  const isSameAMorPM = startTS.format('a') === endTs.format('a');
  const formatString = isSameAMorPM ? 'HH:mm' : 'hh:mm A';

  return `${startTS.format(formatString)}${seperator || '-'}${endTs.format(
    'hh:mm A',
  )}`;
};

export const getFunctionForFilterByCompany = (
  filter: MeetingCompanyFilterType,
  companyId?: number,
) => {
  return (meeting: Meeting) =>
    filter === MeetingCompanyFilterType.ALL || companyId === undefined
      ? true
      : meeting.companyId === companyId;
};

export const filterMeetings = (
  meetings: Meeting[],
  companyFilter: MeetingCompanyFilterType,
  searchTerm?: string,
  companyId?: number,
) => {
  const meetingsFilteredByCompany = meetings.filter(
    getFunctionForFilterByCompany(companyFilter, companyId),
  );

  if (searchTerm?.length === 0) {
    return meetingsFilteredByCompany;
  }
  const fuse = new Fuse(meetingsFilteredByCompany, {
    keys: ['meetingName'],
  });

  return fuse.search(searchTerm || '').map((result) => result.item);
};

/**
 *
 * @description Gives calendar source type from AI fill settings, or fallback of GoogleCalendar
 */
export const getCalendarSourceTypeFromAiFillSettings = (
  settings?: MeetingSettings,
) => {
  return settings?.calendar ?? TimesheetCalendarSourceType.GoogleCalendar;
};
